import { render, staticRenderFns } from "./optionItems-editor.vue?vue&type=template&id=2844e641&scoped=true&"
import script from "./optionItems-editor.vue?vue&type=script&lang=js&"
export * from "./optionItems-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2844e641",
  null
  
)

export default component.exports